import type { Root } from './prototypeTypes';

// One Topic can be represented by its landing card, mini player and now-playing
// card simultaneously. Keep the write fence at that Topic scope, rather than
// on whichever button happened to start the request.
const versions = new WeakMap<object, Map<string, number>>();
const voteVersions = new WeakMap<object, Map<string, number>>();

export function topicFavoriteVersion(root: Root, topicId: string): number {
	return versions.get(root as object)?.get(topicId) ?? 0;
}

export function bumpTopicFavoriteVersion(root: Root, topicId: string): number {
	const scope = root as object;
	const values = versions.get(scope) ?? new Map<string, number>();
	const next = (values.get(topicId) ?? 0) + 1;
	values.set(topicId, next);
	versions.set(scope, values);
	root.querySelectorAll<HTMLElement>('.fav-btn[data-topic-id]').forEach((button) => {
		if (button.dataset.topicId === topicId) button.dataset.topicFavoriteStateVersion = String(next);
	});
	return next;
}

/**
 * Votes use their own fence because the authoritative votes list and the
 * favourites list arrive independently. A late votes response must not undo a
 * successful like/dislike transaction for the same Topic.
 */
export function topicVoteVersion(root: Root, topicId: string): number {
	return voteVersions.get(root as object)?.get(topicId) ?? 0;
}

export function bumpTopicVoteVersion(root: Root, topicId: string): number {
	const scope = root as object;
	const values = voteVersions.get(scope) ?? new Map<string, number>();
	const next = (values.get(topicId) ?? 0) + 1;
	values.set(topicId, next);
	voteVersions.set(scope, values);
	root.querySelectorAll<HTMLElement>('.like-btn[data-topic-id], .dislike-btn[data-topic-id]').forEach((button) => {
		if (button.dataset.topicId === topicId) button.dataset.topicVoteStateVersion = String(next);
	});
	return next;
}
